// İSG Portal — ButtonSet (S33 planı Stage 2, yeni): sayfa başlığının sağındaki aksiyon
// grubu. Sıra (soldan sağa) ÇAĞIRANIN sorumluluğu — bu component yalnız DÜZENİ verir
// (Carbon'da `flex gap-px`, butonlar BİRBİRİNE değer; base derlemede `gap-2`, bugünkü
// çoğu ekranın zaten kullandığı serbest boşluk — PageHeader'ın (Slice 1b) sağ slotu ve
// PermitLifecycleActions gibi gelecekteki tüketiciler için, henüz gerçek bir tüketicisi YOK).

import type { HTMLAttributes } from 'react';
import { cn } from './cn';

export function ButtonSet({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('flex items-center gap-2 carbon:gap-px', className)} {...props}>
      {children}
    </div>
  );
}
